import { connect } from 'react-redux';
import { get } from 'lodash';

const mapFormValuesToProps = (formState, { prefix = '' }) => {
    const formValues = formState.values || {};

    // Use _.get to deal with object prefix keys with arrays e.g. `a[0].lolcats`
    const startDate = get(formValues, `${prefix}startDate`);
    const endDate = get(formValues, `${prefix}endDate`);

    return {
        startDate,
        endDate,
    };
};

const startDateConnector = (component, getFormState, options = {}) =>
    connect((state) => mapFormValuesToProps(getFormState(state), options))(
        component,
    );

export default startDateConnector;
